var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_650",
    "data-name": "Rettangolo 650",
    width: 14,
    height: 19,
    transform: "translate(-1.667 -1.556)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1054",
    "data-name": "Raggruppa 1054",
    transform: "translate(1.667 1.556)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2640",
    "data-name": "Tracciato 2640",
    d: "M274.667,336.389a1.051,1.051,0,0,0-1.014-1.082,1.024,1.024,0,0,0-.866.509v-.032a1.007,1.007,0,0,0-1.879-.572v-.032a1.007,1.007,0,0,0-1.88-.572V331a1.1,1.1,0,0,0-.3-.764.972.972,0,0,0-.716-.318A1.061,1.061,0,0,0,267,331v7.078a.155.155,0,0,1-.09.143.111.111,0,0,1-.149-.032l-1-1.1a.971.971,0,0,0-1.3-.127,1.136,1.136,0,0,0-.447.748,1.174,1.174,0,0,0,.224.86l2.565,3.276a3.7,3.7,0,0,0,2.924,1.479h1.6a3.161,3.161,0,0,0,2.356-1.05,3.66,3.66,0,0,0,.985-2.513Z",
    transform: "translate(-264 -328.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2641",
    "data-name": "Tracciato 2641",
    d: "M265.925,331.117a.316.316,0,0,0,.313-.333,1.989,1.989,0,1,1,3.969,0,.314.314,0,1,0,.626,0,2.616,2.616,0,1,0-5.221,0A.326.326,0,0,0,265.925,331.117Z",
    transform: "translate(-264.179 -328)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/Manual.365f21ad9a062d793b5f1efa108d9acd.svg";
export { ForwardRef as ReactComponent };